import { Box } from '@openfin/ui-library';
import React, { FC, useContext } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { ToggleCenterVisibility, ToggleCenterVisibilitySource } from '../../../store/Actions';
import { Header } from '../../components/Header/Header';
import { SettingsView } from '../../components/SettingsView/SettingsView';
import { HistoryContext } from '../../contexts/HistoryContext';
import { ROUTES } from '../../routes';
import { GlobalProviderStyles } from '../../styles/GlobalProviderStyles';

type Props = ReturnType<typeof mapDispatch>;

const SettingsPanelComponent: FC<Props> = ({ closeCenter }: Props) => {
  const history = useContext(HistoryContext);

  return (
    <Container flexDirection="column">
      <GlobalProviderStyles />
      <Header
        title="Settings"
        onClose={closeCenter}
        onBack={() => history.push(ROUTES.NOTIFICATIONS)}
      />
      <SettingsView />
    </Container>
  );
};

const Container = styled(Box)`
  background: ${({ theme }) => theme.palette.background2};
  border: 1px solid ${({ theme }) => theme.palette.background4};
  height: 100%;
`;

const mapDispatch = (dispatch: Dispatch) => ({
  closeCenter: () =>
    dispatch(new ToggleCenterVisibility(ToggleCenterVisibilitySource.BUTTON, false)),
});

export const SettingsPanel = connect(undefined, mapDispatch)(SettingsPanelComponent);
